export const QUOTE_CO_OPERATION_PREFIX = 'quoteCO';

export const getEndpointForOperation = (operationName?: string): string => {
  // If operation name exists and is in V3 list, use V3 endpoint
  if (operationName && operationName.startsWith(QUOTE_CO_OPERATION_PREFIX)) {
    return '/graphV3';
  }
  
  // All other cases default to V2
  return '/graphV2';
};
